<template>
     <v-row>
    <v-col>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text @click="()=>{this.$router.go(-1)}"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
        <h1>Client Details Configurator</h1>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="loaders.form"
            style="margin-left: 10px;"
        ></v-progress-circular>
        <v-btn class="ml-2" small color="success" :loading="loaders.saveAll" :disabled="loaders.form" @click="saveAll">Save All</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form :disabled="loaders.form">
          <span class="d-flex flex-row align-center my-2">
            <h3>Fields</h3>
            <v-btn fab color="info" x-small class="ml-2" @click="addKeyDialog.isOpen = true"><v-icon>mdi-plus</v-icon></v-btn>
          </span>
          <vue-json-editor v-model="data.globals.clientDetails" :show-btns="false" :expandedOnStart="true"></vue-json-editor>
          <v-row v-if="data.globals?.clientDetails">
            <v-col v-for="(field, f) of Object.keys(data.globals.clientDetails)" :key="f" cols="12" md="6">
              <v-card outlined class="d-flex flex-column mt-2">
                <v-card-text>
                  <v-text-field dense outlined v-model="data.globals.clientDetails[field]" :label="field"/>
                  <span>
                    <v-btn color="error" small @click="removeKey(field)">Delete</v-btn>
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <v-dialog v-model="addKeyDialog.isOpen" width="650">
      <v-card>
        <v-card-title>Add New Key</v-card-title>
        <v-card-text>
          <v-text-field outlined label="Key" v-model="addKeyDialog.key"/>
        </v-card-text>
        <v-card-actions class="pl-5 pb-5">
          <v-btn text @click="addKeyDialog.isOpen = false" color="error">Cancel</v-btn>
          <v-btn @click="addKey" :disabled="!addKeyDialog.key.trim()" color="success">Add Key</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
    </v-col>
   </v-row>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import utils from "../../plugins/helpers"
import vueJsonEditor from 'vue-json-editor'

export default {
  name: 'Home',
  components: {
    vueJsonEditor
  },
  data () {
    return {
      utils: utils,

      snackObj: {
        state: false,
        color: '',
        text: ''
      },

      isEditable: false,
      isCreate: true,

      requiredRules: [
        v => !!v || 'Field is required.'
      ],

      requiredBool: true,

      data: {
        globals: {}
      },
      validForm: false,

      loaders: {
        form: false,
        saveAll: false
      },

      addKeyDialog: {
        isOpen: false,
        key: "",
      }
    }
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  async mounted(){
    try {
      await this.fetchData();

    } catch (error) {
      console.error(error)
      this.snack(error.msg || error.msg?.message || error, "error");
    }
  },
  methods: {
    async fetchData(){
      try{
        this.loaders.form = true;

        let res = await axios.get(`${this.getEndpoint}/api/clientDetailsConfigurator`)
        if(res.data.error) throw res.data.error
        this.data = res.data.data

        console.log(this.data)
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    async saveAll(){
      try{
        this.loaders.form = true;

        console.log("saving", this.data)

        for(let key of Object.keys(this.data.globals)){
          if(typeof this.data.globals[key]!=='boolean' && !Array.isArray(this.data.globals[key])){
            if(this.data.globals[key]===null || this.data.globals[key]===undefined || this.data.globals[key].length===0){
              throw `Value ${key} cannot be empty`;
            }
          }
        }

        let res = await axios.put(`${this.getEndpoint}/api/clientDetailsConfigurator/saveAll`, {data: this.data})
        if(res.data.error) throw res.data.error

        this.snack(`All saved!`, "success");

        await this.fetchData();
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    addKey(){
      if(!this.data.globals){
        this.data.globals = {};
      }
      if(!this.data.globals.clientDetails){
        this.data.globals.clientDetails = {};
      }

      this.data.globals.clientDetails[this.addKeyDialog.key] = "";

      this.addKeyDialog = {
        isOpen: false,
        key: ""
      }

      this.$forceUpdate();
    },
    removeKey(key){
      delete this.data.globals?.clientDetails[key];
      this.$forceUpdate();
    }
  }
}
</script>
